import * as Yup from 'yup';
import { useState, useContext } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
// material
import {
  Link,
  Stack,
  Checkbox,
  TextField,
  IconButton,
  InputAdornment,
  FormControlLabel,
  Typography,
  Button
} from '@mui/material';
import { makeStyles, styled } from '@mui/styles';
import { ToastContainer, toast } from 'material-react-toastify';
import { useTranslation } from 'react-i18next';
import 'material-react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { CircleSpinner } from 'react-spinners-kit';
import jwtDecode from 'jwt-decode';
import secureLocalStorage from 'react-secure-storage';
import AuthContext from '../../../context/AuthContext';
import './style.css';
// ----------------------------------------------------------------------
const useStyles = makeStyles((theme) => ({
  overrides: {
    MuiFilledInput: {
      root: {
        backgroundColor: 'red',
        '&:hover': {
          backgroundColor: 'rgba(255,255,255,1)'
        },
        '&.Mui-focused': {
          backgroundColor: 'rgba(255,255,255,1)'
        }
      }
    }
  },
  cssFiledInput: {
    '& .css-s6y6h2-MuiInputBase-root-MuiFilledInput-root': {
      borderBottom: '2px solid yellow !important'
    },
    '& .Mui-focused': {
      borderBottom: '1px solid blue'
    }
  },
  notchedFiled: {},
  cssFocused: {},
  error: {},
  disabled: {}
}));

const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#f78181'
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#f78181'
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'lightgray'
    },
    '&:hover fieldset': {
      borderColor: '#f78181'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#f78181'
    }
  }
});

export default function LoginForm() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [noti, setNoti] = useState(false);
  const [spiner, setSpiner] = useState(false);
  const [t, i18n] = useTranslation();

  const notifyErrorLogin = (messageError) => {
    setNoti(true);
    toast.error(messageError, {
      position: 'bottom-right',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });
  };
  const { user, setUser, saveUser } = useContext(AuthContext);
  const LoginSchema = Yup.object().shape({
    username: Yup.string().required('Email or phone (Required)'),
    password: Yup.string().required('Password is required')
  });

  const formik = useFormik({
    initialValues: {
      username: '',
      password: '',
      type: 'web'
    },
    validationSchema: LoginSchema,
    onSubmit: (values) => {
      setSpiner(true);
      console.log('data', values);
      const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
      axios({
        method: 'post',
        url: `${API_ENDPOINT}/api/token/`,
        data: values
      })
        .then((res) => {
          setSpiner(!spiner);
          if (res.data.is_educator || res.data.is_parent) {
            setSpiner(false);
            notifyErrorLogin('Can not find an account with this credentials. Try again.');
          } else {
            const currentuser = res.data;
            console.log('Login', res.data);
            console.log('token', res.data.access);
            console.log('refresh', res.data.refresh);
            localStorage.setItem('access', res.data.access);
            localStorage.setItem('refresh', res.data.refresh);
            localStorage.setItem('user', JSON.stringify(currentuser));
            saveUser(() =>
              localStorage.getItem('access') ? jwtDecode(localStorage.getItem('access')) : null
            );
            navigate('/dashboard');
          }
        })
        .catch((err) => {
          setSpiner(false);
          notifyErrorLogin(err.message);
        });
    }
  });

  const { errors, touched, values, isSubmitting, getFieldProps } = formik;

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  return (
    <FormikProvider value={formik}>
      {spiner ? (
        <CircleSpinner size={30} color="#f78181" loading={spiner} />
      ) : (
        <>
          <Stack style={{ marginBottom: 50 }}>
            <Typography color="#F78181" variant="h4" gutterBottom>
              {t('connectez-vous')}
            </Typography>
            <Typography sx={{ color: 'text.secondary' }}>{t('identifiez')}</Typography>
          </Stack>
          <Form
            autoComplete="off"
            noValidate
            onSubmit={(e) => {
              e.preventDefault();
              formik.handleSubmit(e);
            }}
          >
            <ToastContainer />
            <Stack spacing={3}>
              <CssTextField
                fullWidth
                required
                autoComplete="username"
                type="text"
                label={`${t('email')} ${t('ou')} ${t('phone')}`}
                {...getFieldProps('username')}
                error={Boolean(touched.username && errors.username)}
                helperText={touched.username && errors.username}
              />

              <CssTextField
                fullWidth
                required
                autoComplete="current-password"
                type={showPassword ? 'text' : 'password'}
                label={t('password')}
                {...getFieldProps('password')}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleShowPassword} edge="end">
                        <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
                error={Boolean(touched.password && errors.password)}
                helperText={touched.password && errors.password}
              />
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ my: 2 }}
            >
              <a
                style={{
                  color: '#F78181',
                  textDecoration: 'none',
                  cursor: 'pointer',
                  fontFamily: 'Open Sans, sans-serif',
                  fontWeight: 600,
                  fontSize: 14
                }}
                href="http://161.97.116.141/accounts/reset_password/"
              >
                {t('Mot_de_passe_oublié')}
              </a>
            </Stack>
            <Button
              style={{ backgroundColor: '#F78181' }}
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              loading={isSubmitting}
            >
              {t('se_connecter')}
            </Button>
          </Form>
        </>
      )}
    </FormikProvider>
  );
}
